import React from "react";
import { Typography, Divider, Card, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ArrowRightOutlined,
  LinkOutlined,
  CaretRightFilled,
} from "@ant-design/icons";
import hederImage from "../assets/insights-header.png";
import dummyImage from "../assets/Cloud-Computing.jpg";

const { Title, Paragraph, Text } = Typography;

const tempData = [
  {
    title: "How clover bay partnered with a leading European mobile virtual",
    description:
      "Neque porro est qui dolorem ipsum quia quaed inventor veritatis et quasi architecto beatae vitae dicta sunt explicabo. Aelltes port lacus quis enim var sed efficitur turpis gilla sed sit.",
    image: dummyImage,
    link: "www.cloverbay.com",
  },
  {
    title: "How clover bay partnered with a leading European mobile virtual",
    description:
      "Neque porro est qui dolorem ipsum quia quaed inventor veritatis et quasi architecto beatae vitae dicta sunt explicabo. Aelltes port lacus quis enim var sed efficitur turpis gilla sed sit.",
    image: dummyImage,
    link: "www.cloverbay.com",
  },
  {
    title: "How clover bay partnered with a leading European mobile virtual",
    description:
      "Neque porro est qui dolorem ipsum quia quaed inventor veritatis et quasi architecto beatae vitae dicta sunt explicabo. Aelltes port lacus quis enim var sed efficitur turpis gilla sed sit.",
    image: dummyImage,
    link: "www.cloverbay.com",
  },
];

const Insights = () => {
  return (
    <div style={{ marginTop: "110px", background: "white" }}>
      <div
        className="industries-title-overlay"
        data-aos="fade-down"
        data-aos-duration="700"
        style={{ background: `url(${hederImage})` }}
      >
        <div className="industries-hero-title">Insights</div>
        {/* <div className="industries-hero-subtitle">
          {" "}
          At clover bay technologies, we empower businesses across various
          sectors to achieve digital transformation and operational excellence.
        </div> */}
      </div>
      <div
        className="section-content service-main-dev"
        style={{ paddingTop: "50px" }}
      >
        <Row gutter={[30, 30]}>
          <Col lg={16}>
            {tempData.map((item, index) => (
              <div key={index}>
                <img className="insight-image" alt="example" src={item.image} />
                <div className="insight-title">{item.title}</div>
                <div className="insight-description">{item.description}</div>
                {/* <Button type="primary" href={item.link} target="_blank">
                        Read More <CaretRightFilled />
                    </Button> */}
                <Button
                  size="large"
                  shape="round"
                  className="explore-btn"
                >
                  Read More <CaretRightFilled />
                </Button>
                {index < tempData.length - 1 && <Divider style={{ margin: "40px 0px" }} />}
              </div>
            ))}
          </Col>
          <Col lg={8}>
            <Card
              className="industry-navbar"
              style={{ height: "150px" }}
            ></Card>
            <Card
              className="industry-navbar"
              style={{ height: "400px" }}
            ></Card>
            <Card
              className="industry-navbar"
              style={{ height: "300px" }}
            ></Card>
            <Card
              className="industry-navbar"
              style={{ height: "150px" }}
            ></Card>
            <Card
              className="industry-navbar"
              style={{ height: "300px" }}
            ></Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Insights;

